<panel>
  <div class="center" *ngIf="loadingPreferences">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
  <ul class="preferences" *ngIf="!loadingPreferences">
    <li>
      <preference [label]="'Email Address' | translate | async" [description]="'This is the email address that all emails, reports, etc. for your account will be sent to.' | translate | async">
        <click-to-edit-text [data]="email | aesDecrypt" (change)="updateEmail($event.target.value)"></click-to-edit-text>
      </preference>
    </li>
    <li>
      <preference [label]="'Username' | translate | async" [description]="'This is what you use to sign in to both the web application and the mobile application.' | translate | async">
        <click-to-edit-text [data]="username | aesDecrypt" (change)="updateUsername($event.target.value)"></click-to-edit-text>
      </preference>
    </li>
    <li>
      <preference [description]="'This is the password you use to sign in to both the web application and the mobile application to perform inspections on.' | translate | async" [label]="'Change Your Password' | translate | async">
        <ul class="items">
          <li class="item">
            <item [label]="'New Password' | translate | async" [loading]="false">
              <input #password1 type="password" class="password-input" placeholder="******" />
            </item>
          </li>
          <li class="item">
            <item [label]="'Repeat New Password' | translate | async" [loading]="false">
              <input #password2 type="password" class="password-input" placeholder="******" />
            </item>
          </li>
          <li class="item">
            <button mat-raised-button (click)="updatePasswordClicked(password1.value, password2.value)" [class.loading]="savingUpdatePassword">{{'Update Password' | translate | async}}</button>
          </li>
        </ul>
      </preference>
    </li>
  </ul>
</panel>